import { PageLoadEvents, track } from '@mc/track-event'

/**
 * Which of the experiment's two plans-page modules came into view. Neither has
 * a fitting member in `Locations`, so the values are declared here and are the
 * tracking contract for this event.
 */
export const CERTS_ADD_ON_SURFACE = {
  CARD: 'plans-certificates-add-on-card',
  PRIMER: 'plans-primer-certificates-value',
} as const

export type CertsAddOnSurface =
  (typeof CERTS_ADD_ON_SURFACE)[keyof typeof CERTS_ADD_ON_SURFACE]

const CERTS_ADD_ON_VIEWED_EVENT = 'Certificates Add-On Viewed'

/**
 * Fires once per mount, the first time the module clears `TrackingContainer`'s
 * dwell threshold. Both modules render only for an enrolled visitor, so this
 * measures how many of them actually saw the offer rather than merely loaded a
 * page that contained it.
 */
export const trackCertsAddOnViewed = (surface: CertsAddOnSurface) =>
  track(CERTS_ADD_ON_VIEWED_EVENT, {
    surface,
    page_source: PageLoadEvents.PLANS,
  })
